export const API_KEY = "f12b6244eefa590e1165a300f6effab3";
export const IMAGES_PATH = "https://image.tmdb.org/t/p";
export const COVER_PLACEHOLDER = "https://via.placeholder.com/92x138.png?text=No+Cover";